module.exports = __webpack_public_path__ + "static/media/julesMobile.8e9f515d.png";